import {DateTime} from 'luxon';

export const fromPhpDate = (date: string): DateTime => {
  return DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss');
};
